import {
  EventHandicapMode,
  EventMensTeeType,
  EventPinType,
  EventsWindSpeed,
  EventWomensTeeType,
  Weather,
  WindDirection,
  AutoConcede,
  AutoContinue,
  AutoGimme,
  RoundType,
  Gender,
  GimmeDistance,
  HandicapMode,
  HandicapPercentage,
  PinType,
  Ranges,
  ScoringType,
  SimStatus,
  TeeType,
  WindSpeed,
  Rounds,
  EventCompetitionType,
  Ground,
  EventGimmeDistance,
  Sky,
  TimeOfDay,
  LeagueType,
  LeagueScoring,
  LeagueHandicapMethod,
  LeagueTeamSize,
  LeagueRoundCompetitionType,
  TeamPlayFormat,
  MatchPlayAssignment,
  MatchPlayStyle,
  MatchPlayTeamStyle,
  LeagueHandicapMode,
  UnityGames,
  NoPuttMode,
  EventMaxPerHoleType,
  EventRoundSkillLevel,
  LeagueCompetitionType,
  ScoringTypes,
} from "types/enums";
import type { Option, SimulatorState } from "Models";
import { titleCase } from "text-case";
import { first } from "../object";

const stringIsNumber = (value: string): boolean => !Number.isNaN(Number(value));

/*
export function titleCase(str: string) {
  return str
    ? str
        .toString()
        .replaceAll("_", " ")
        .toLowerCase()
        .split(" ")
        .map(function (word) {
          return word.replace(word[0], word[0].toUpperCase());
        })
        .join(" ")
    : "";
}

export function camelCasetoTitleCase(str: string) {
  return str
    ? str
        .toString()
        .replaceAll("_", " ")
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, function (str) {
          return str.toUpperCase();
        })
        .toLowerCase()
        .split(" ")
        .map(function (word) {
          return word.replace(word[0], word[0]?.toUpperCase());
        })
        .join(" ")
    : "";
}*/

export function enumNameToLabel(str: string) {
  return (
    str.toString().charAt(0).toUpperCase() +
    str
      .slice(1)
      .replace(/([A-Z])/g, " $1")
      .trim()
  );
}

export function enumToArray<T extends Record<string, string | number>>(
  enumme: T,
): Array<T[keyof T]> {
  return Object.keys(enumme)
    .filter(stringIsNumber)
    .map((key) => enumme[key as keyof T]);
}

export function roundConfigEnumToReactSelectOptions<
  T extends Record<string, string | number>,
>(enumme: T, format: boolean = true): Option<T[keyof T]>[] {
  const arrayObjects: Option<T[keyof T]>[] = [];

  for (const [propertyKey, propertyValue] of Object.entries(enumme)) {
    if (!Number.isNaN(Number(propertyKey))) {
      continue;
    }
    arrayObjects.push({
      value: propertyValue as T[keyof T],
      label: format ? titleCase(propertyKey) : propertyKey,
    });
  }

  return arrayObjects;
}

export const greenStimpOptions: Option[] = [
  { label: "8", value: 8 },
  { label: "8.5*", value: 8.5 },
  { label: "9", value: 9 },
  { label: "9.5", value: 9.5 },
  { label: "10", value: 10 },
  { label: "10.5", value: 10.5 },
  { label: "11", value: 11 },
  { label: "11.5", value: 11.5 },
  { label: "12", value: 12 },
  { label: "12.5", value: 12.5 },
  { label: "13", value: 13 },
  { label: "13.5", value: 13.5 },
  { label: "14", value: 14 },
];

export function defaultGreenStimp(stimpOptions: Option<number>[]): number {
  return (
    stimpOptions.find((option) => option.label.includes("*"))?.value ?? 8.5
  );
}

export const trueFalseOptions: Option<boolean>[] = [
  { label: "On", value: true },
  { label: "Off", value: false },
];

export const roundConfigEnumsAsReactSelectOptions = {
  autoConcede: roundConfigEnumToReactSelectOptions(AutoConcede),
  autoContinue: roundConfigEnumToReactSelectOptions(AutoContinue),
  autoGimme: roundConfigEnumToReactSelectOptions(AutoGimme),
  gameType: roundConfigEnumToReactSelectOptions(RoundType),
  gender: roundConfigEnumToReactSelectOptions(Gender),
  gimmeDistance: roundConfigEnumToReactSelectOptions(GimmeDistance),
  eventGimmeDistance: roundConfigEnumToReactSelectOptions(EventGimmeDistance),
  handicapMode: roundConfigEnumToReactSelectOptions(HandicapMode),
  leagueHandicapMode: roundConfigEnumToReactSelectOptions(LeagueHandicapMode),
  handicapPercentage: roundConfigEnumToReactSelectOptions(HandicapPercentage),
  pinType: roundConfigEnumToReactSelectOptions(PinType),
  ranges: roundConfigEnumToReactSelectOptions(Ranges),
  scoringType: roundConfigEnumToReactSelectOptions(ScoringType),
  teeType: roundConfigEnumToReactSelectOptions(TeeType),
  windSpeed: roundConfigEnumToReactSelectOptions(WindSpeed),
  rounds: roundConfigEnumToReactSelectOptions(Rounds),
  eventCompetitionType:
    roundConfigEnumToReactSelectOptions(EventCompetitionType),
  eventMensTee: roundConfigEnumToReactSelectOptions(EventMensTeeType),
  eventWomensTee: roundConfigEnumToReactSelectOptions(EventWomensTeeType),
  eventPinType: roundConfigEnumToReactSelectOptions(EventPinType),
  eventSkillLevel: roundConfigEnumToReactSelectOptions(EventRoundSkillLevel),
  groundConditions: roundConfigEnumToReactSelectOptions(Ground),
  windDirection: roundConfigEnumToReactSelectOptions(WindDirection, false),
  eventsWindSpeed: roundConfigEnumToReactSelectOptions(EventsWindSpeed),
  eventsHandicapMode: roundConfigEnumToReactSelectOptions(EventHandicapMode),
  weather: roundConfigEnumToReactSelectOptions(Weather),
  skyConditions: roundConfigEnumToReactSelectOptions(Sky),
  timeOfDay: roundConfigEnumToReactSelectOptions(TimeOfDay),
  stimpSetting: greenStimpOptions,
  mulligan: trueFalseOptions,
  autoDrop: trueFalseOptions,
  leagueType: roundConfigEnumToReactSelectOptions(LeagueType),
  leagueCompetitionType: roundConfigEnumToReactSelectOptions(
    LeagueCompetitionType,
  ),
  leagueRoundCompetitionType: roundConfigEnumToReactSelectOptions(
    LeagueRoundCompetitionType,
  ),
  leagueScoring: roundConfigEnumToReactSelectOptions(LeagueScoring),
  leagueHandicap: roundConfigEnumToReactSelectOptions(LeagueHandicapMethod),
  leagueTeamSize: roundConfigEnumToReactSelectOptions(LeagueTeamSize),
  teamPlayFormat: roundConfigEnumToReactSelectOptions(TeamPlayFormat),
  matchPlayAssignment: roundConfigEnumToReactSelectOptions(MatchPlayAssignment),
  matchPlayStyle: roundConfigEnumToReactSelectOptions(MatchPlayStyle),
  matchPlayTeamStyle: roundConfigEnumToReactSelectOptions(MatchPlayTeamStyle),
  unityGames: roundConfigEnumToReactSelectOptions(UnityGames),
  noPuttMode: roundConfigEnumToReactSelectOptions(NoPuttMode),
};

export const serviceRequestEnumDisplayName = (str: string) => {
  const name = str?.slice(11)?.toLowerCase();
  return name?.charAt(0)?.toUpperCase() + name.slice(1);
};

export const unityGameEnumDisplayNameKeyedByString: Record<UnityGames, string> =
  {
    [UnityGames.GAME_BALLSTRIKING_NONE]: "",
    [UnityGames.GAME_BALLSTRIKING_FORE]: "Fore",
    [UnityGames.GAME_BALLSTRIKING_BENDIT]: "Bend It",
    [UnityGames.GAME_BALLSTRIKING_CONQUEST]: "Conquest",
    [UnityGames.GAME_BALLSTRIKING_RAZORSEDGE]: "Razors Edge",
    [UnityGames.GAME_BARARCADE_NONE]: "",
    [UnityGames.GAME_BARARCADE_DARTS]: "Darts",
    [UnityGames.GAME_BARARCADE_CORNHOLE]: "Cornhole",
    [UnityGames.GAME_BARARCADE_BEERPONG]: "Beer Pong",
    [UnityGames.GAME_BARARCADE_SKEEBALL]: "Skeeball",
    [UnityGames.GAME_MINIGOLF_NONE]: "",
    [UnityGames.GAME_MINIGOLF_GALACTICGREENS]: "Galactic Greens",
    [UnityGames.GAME_MINIGOLF_LOSTLAGOON]: "Lost Lagoon",
    [UnityGames.GAME_MINIGOLF_MYSTERYREEF]: "Mystery Reef",
    [UnityGames.GAME_PARTY_CTP]: "Closest to the Pin Party",
    [UnityGames.GAME_PARTY_LD]: "Long Drive Party",
    [UnityGames.GAME_SOCCER]: "Soccer",
    [UnityGames.GAME_BALLSTRIKING_DIALEDIN]: "Dialed In",
    [UnityGames.GAME_BALLSTRIKING_GOLFERABILITYTEST]:
      "Golfer Ability Test (GAT)",
    [UnityGames.GAME_BALLSTRIKING_FLAGHUNTER]: "Flag Hunter",
    [UnityGames.GAME_MULTISPORT_STICKBALL]: "Stickball",
    [UnityGames.GAME_MULTISPORT_BASEBALL]: "Baseball",
    [UnityGames.GAME_MULTISPORT_FOOTBALL]: "Football",
    [UnityGames.GAME_MULTISPORT_TEXASGOLFEM]: "Texas Golf'em",
    [UnityGames.GAME_MULTISPORT_PIRATEPARTY]: "Pirate Party",
    [UnityGames.GAME_BALLSTRIKING_PUTTPOOL]: "Putt Pool",
    [UnityGames.GAME_GOLFNSKEET_GOLFNSKEET]: "Golf N Skeet",
  };

export const simStatusEnumDisplayNameKeyedByString: Record<SimStatus, string> =
  {
    [SimStatus.STATUS_SIM_OFF]: "Off",
    [SimStatus.STATUS_SIM_START]: "Starting",
    [SimStatus.STATUS_SETUP_ENTER]: "Entering Setup",
    [SimStatus.STATUS_SETUP_IDLE]: "Setup Idle",
    [SimStatus.STATUS_SETUP_EXIT]: "Exiting Setup",
    [SimStatus.STATUS_RANGE_ENTER]: "Entering Range",
    [SimStatus.STATUS_RANGE_SHOT]: "Range Taking Shot",
    [SimStatus.STATUS_RANGE_IDLE]: "Range Idle",
    [SimStatus.STATUS_RANGE_EXIT]: "Range Exit",
    [SimStatus.STATUS_RND_START]: "Round Starting",
    [SimStatus.STATUS_RND_SHOT]: "Round Taking Shot",
    [SimStatus.STATUS_RND_IDLE]: "Round Idle",
    [SimStatus.STATUS_RND_HOLE_END]: "Hole Ending",
    [SimStatus.STATUS_RND_END]: "Round Ending",
    [SimStatus.STATUS_SIM_EXIT]: "Sim Exiting",
    [SimStatus.STATUS_TIMER_PAUSE]: "Timer Pausing",
    [SimStatus.STATUS_TIMER_UNPAUSE]: "Timer Unpausing",
    [SimStatus.STATUS_TIMER_EXPIRED]: "Timer Expired",
    [SimStatus.STATUS_MAIN_MENU]: "Main Menu",
    [SimStatus.STATUS_COURSE_MENU]: "Course Selection Menu",
    [SimStatus.STATUS_COURSE_SETUP]: "Round Setup Menu",
    [SimStatus.STATUS_MINIGAMES_MENU]: "Minigames Menu",
    [SimStatus.STATUS_UNITY_GAME_RUNNING]: "Playing Minigame",
    [SimStatus.STATUS_UNITY_GAME_FINISHED]: "Finished Playing Minigame",
    [SimStatus.STATUS_OVERDRIVE_RANGE]: "Playing Overdrive Range",
    [SimStatus.STATUS_CLUBFIT_MENU]: "Club Fitting Menu",
    [SimStatus.STATUS_MEDIA_MENU]: "Media Menu",
    [SimStatus.STATUS_RANGE_MENU]: "Range Menu",
    [SimStatus.STATUS_EVENTS_MENU]: "Events Menu",
    [SimStatus.STATUS_SIM_ON]: "On",
  };

export const eventsWindSpeedDisplayNameKeyedByString: Record<
  EventsWindSpeed,
  string
> = {
  [EventsWindSpeed.CALM]: "Calm",
  [EventsWindSpeed.LIGHT]: "Light",
  [EventsWindSpeed.MODERATE]: "Moderate",
  [EventsWindSpeed.STRONG]: "Strong",
  [EventsWindSpeed.VERY_STRONG]: "Very Strong",
};

export const windDirectionDisplayNameKeyedByString: Record<
  WindDirection,
  string
> = {
  [WindDirection.N]: "North",
  [WindDirection.NE]: "Northeast",
  [WindDirection.E]: "East",
  [WindDirection.SE]: "Southeast",
  [WindDirection.S]: "South",
  [WindDirection.SW]: "Southwest",
  [WindDirection.W]: "West",
  [WindDirection.NW]: "Northwest",
};

export const skyDisplayNameKeyedByString: Record<Sky, string> = {
  [Sky.CLEAR]: "Clear",
  [Sky.FAIR]: "Fair",
  [Sky.PARTLY_CLOUDY]: "Partly Cloudy",
  [Sky.CLOUDY]: "Cloudy",
  [Sky.FOG]: "Foggy",
};

export const groundDisplayNameKeyedByString: Record<Ground, string> = {
  [Ground.VERY_DRY]: "Very Dry",
  [Ground.DRY]: "Dry",
  [Ground.NORMAL]: "Normal",
  [Ground.WET]: "Wet",
  [Ground.VERY_WET]: "Very Wet",
};

export const pinTypeDisplayNameKeyedByString: Record<PinType, string> = {
  [PinType.NOVICE]: "Novice",
  [PinType.INTERMEDIATE]: "Intermediate",
  [PinType.ADVANCED]: "Advanced",
};

export const teeTypeDisplayNameKeyedByString: Record<TeeType, string> = {
  [TeeType.RED]: "Red",
  [TeeType.WHITE]: "White",
  [TeeType.BLUE]: "Blue",
  [TeeType.BLACK]: "Black",
  [TeeType.GOLD]: "Gold",
  [TeeType.JUNIOR]: "Junior",
  [TeeType.SKILL]: "Skill",
};

export const eventMaxPerHoleTypeDisplayNameKeyedByString: Record<
  EventMaxPerHoleType,
  string
> = {
  [EventMaxPerHoleType.NONE]: "None",
  [EventMaxPerHoleType.DOUBLE_PAR]: "Double Par",
  [EventMaxPerHoleType.PAR_PLUS_3]: "Par + 3",
  [EventMaxPerHoleType.PAR_PLUS_4]: "Par + 4",
  [EventMaxPerHoleType.PAR_PLUS_5]: "Par + 5",
  [EventMaxPerHoleType.TEN]: "10 Strokes",
  [EventMaxPerHoleType.ESC]: "ESC",
};

export const handicapModeDisplayNameKeyedByString: Record<
  HandicapMode,
  string
> = {
  [HandicapMode.ABSOLUTE]: "Absolute",
  [HandicapMode.RELATIVE]: "Relative",
  [HandicapMode.OFF]: "Off",
};

export const gimmeDistanceDisplayNameKeyedByString: Record<
  GimmeDistance,
  string
> = {
  [GimmeDistance.OFF]: "Off",
  [GimmeDistance["3FT"]]: "3 ft",
  [GimmeDistance["6FT"]]: "6 ft",
  [GimmeDistance["9FT"]]: "9 ft",
  [GimmeDistance["12FT"]]: "12 ft",
};

/**
 * Gets a human-readable display name for an enum value using a provided mapping
 * @param enumValue The enum value to get the display name for
 * @param displayNameMap A Record mapping enum values to their display names
 * @returns The display name for the enum value, or a string version of the enum value if not found
 * @example
 * // Define a mapping
 * const windSpeedDisplayNames: Record<EventsWindSpeed, string> = {
 *   [EventsWindSpeed.CALM]: "Calm",
 *   [EventsWindSpeed.LIGHT]: "Light",
 * };
 *
 * // Get display name
 * const displayName = getEnumDisplayName(EventsWindSpeed.CALM, windSpeedDisplayNames); // "Calm"
 * const displayName2 = getEnumDisplayName(123, windSpeedDisplayNames); // "123"
 */
export const getEnumDisplayName = <T extends Record<string, string | number>>(
  enumValue: T[keyof T] | undefined,
  displayNameMap: Record<T[keyof T], string>,
): string => {
  if (enumValue === undefined) return "Unknown";
  return displayNameMap[enumValue] || String(enumValue);
};

export function getEnumKeyByEnumValue<T extends { [index: string]: string }>(
  myEnum: T,
  enumValue: string,
): keyof T | undefined {
  const keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue);
  return first(keys);
}

export function getStateDisplay(state: SimulatorState): string {
  if (
    state.status === SimStatus.STATUS_UNITY_GAME_RUNNING ||
    state.status === SimStatus.STATUS_UNITY_GAME_FINISHED
  ) {
    let game = "";
    if (state.game) {
      game = unityGameEnumDisplayNameKeyedByString[state.game];
    }
    return (
      `${simStatusEnumDisplayNameKeyedByString[state.status]}` +
      (game !== "" ? ` - ${game}` : "")
    );
  }

  return simStatusEnumDisplayNameKeyedByString[state.status];
}

const scoringTypesToUiScoringType: { [K in ScoringTypes]?: ScoringType } = {
  [ScoringTypes.SCORING_STROKE]: ScoringType.STROKE,
  [ScoringTypes.SCORING_MATCH]: ScoringType.MATCH,
  [ScoringTypes.SCORING_SCRAMBLE]: ScoringType.SCRAMBLE,
  // Others intentionally unmapped
};

export function toUiScoringType(
  scoring: ScoringTypes | undefined | null,
): ScoringType | undefined {
  if (scoring === null || scoring === undefined) return undefined;
  return scoringTypesToUiScoringType[scoring];
}

export function coalesceRoundEnumValue<T extends string | number>(
  raw: unknown,
  fallback: T | undefined,
): T | undefined {
  if (raw === undefined || raw === null || raw === "") return fallback;
  return raw as T;
}
